<template>
  <a-layout class="individual-layout">
    <IndividualInfoHeader />
    <IndividualInfoTitle />
    <IndividualPointsList />
  </a-layout>
</template>

<script>
    import IndividualInfoHeader from "../../components/individualInfo/IndividualInfoHeader.vue";
    import IndividualInfoTitle from "../../components/individualInfo/IndividualInfoTitle.vue";
    import IndividualPointsList from "../../components/individualInfo/IndividualPointsList.vue";

    export default {
        name: 'IndividualScheduleRouteContainer',
        components: {
            IndividualInfoHeader,
            IndividualInfoTitle,
            IndividualPointsList,
        },
        beforeRouteEnter(to, from, next) {
          sessionStorage.setItem('scheduleRoutePageFromPathName', from.name);
          next();
        },
    }
</script>